
import ColumnsCheckboxes from "@/components/statistics/ColumnsCheckboxes.vue";
import ReportConstructorWrap from "@/components/statistics/extended-report/ReportConstructorWrap.vue";
import ReportFilterByDate from "@/components/statistics/extended-report/ReportFilterByDate.vue";
import ReportFilters from "@/components/statistics/extended-report/ReportFilters.vue";
import { eventBus } from "@/eventbus";
import { ExtendedReportFilters } from "@/services/TablePage/extendedReport";
import { useStatsCompareStore } from "@/store_v3/StatsCompareStore";
import { IFilter } from "@/types";
import { Component, PropSync, Ref, Vue } from 'vue-property-decorator';
import { Getter } from "vuex-class";

@Component({
    components: { ReportFilterByDate, ReportFilters, ColumnsCheckboxes, ReportConstructorWrap },
})
export default class ReportConstructor extends Vue {
    @PropSync('filters', { required: true }) filtersSync!: ExtendedReportFilters;
    @PropSync('isByDateClick', { required: false }) isByDateClickSync!: 'conversion' | 'conversion-click';
    @PropSync('isCalculateCommission', { required: false }) isCalculateCommissionSync!: boolean;
    @Ref('report-filters') reportFilters!: ReportFilters;
    @Getter('GET_FILTERS_PARAMS_OBJECT') getFiltersParamsObject;

    compareStore = useStatsCompareStore();

    get groupFilter(): IFilter {
        return this.filtersSync.filters.find(i => i.id === 'group')!;
    }

    submitFilters(): void {
        this.reportFilters.filtersDesign.submit();
    }

    clearFilters(): void {
        eventBus.$emit('go-to-first-page');
        eventBus.$emit('clear-subs');
        this.$emit('clear');
    }

    get getEmptyConditions(): object {
        const objErrors = {
            isEmptyParams: !this.getFiltersParamsObject?.columns?.some(el => el.includes('mt_')),
            isEmptyColumns: !this.getFiltersParamsObject?.columns?.some(el => el.includes('dm_')),
        };
        for (const i in objErrors) {
            if (!objErrors[i]) {
                this.$delete(objErrors, i);
            }
        }
        return objErrors;
    }

    updateCompare(): void {
        const filters = this.filtersSync.filters;
        let currentDate = filters[0].select;
        let compareDate = filters[1].select;

        if (currentDate.length === 1) {
            currentDate = [currentDate[0], currentDate[0]];
        }
        if (compareDate.length === 1) {
            compareDate = [compareDate[0], compareDate[0]];
        }

        this.compareStore.currentDate = currentDate;
        this.compareStore.compareDate = compareDate;
        this.submitFilters();
    }
}
